import React from 'react';
import { syncApplyCmsThemeFromStartPage } from './useThemeColors';

/**
 * Component that loads theme colors from CMS on mount
 * This component renders nothing, it just runs the theme loading hook
 */
const ThemeLoader = ({ startPage }) => {
  syncApplyCmsThemeFromStartPage(startPage);
  return null;
};

export default ThemeLoader;
